export enum RoutePaths {
  Home = '/',
  Private = '/private',
  Login = '/login',
  About = '/about',
  Error = '/error',
  Onboarding = '/onboarding',
  SocialCalendarManagement = 'social-calendar-management',
  SocialCalendarLandingPage = 'social-calendar',
  EventsCalendar = 'events-calendar',
  PostsOverview = 'posts-overview',
  PostsClient = 'posts',
  PostClient = 'post',
  SourceContentManagement = 'source-content-management',
  SourceContentIdeas = 'source-content-ideas',
  Settings = 'settings',
  SettingsWithId = 'settings/:id',
  SocialMediaAccessManagement = 'social-media-access-management',
  GrantFeedback = 'grant-feedback',
  MaggieHome = '/maggie',
  GrantHome = '/grant',
  GrantDBpage = '/grant/grants',
  Opportunities = '/opportunities',
  Workspace = '/workspace',
  OnboardingAgent = '/onboarding-agent',
}
